import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, isRef as _isRef, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-067ed006"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "housing-card__header"
}
const _hoisted_2 = { class: "housing-card__heading-wrapper" }
const _hoisted_3 = { class: "headline-4" }
const _hoisted_4 = { class: "body-2 housing-card__category-tag" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "housing-card__divider" }, null, -1))
const _hoisted_6 = { class: "housing-card__expandable-section" }
const _hoisted_7 = {
  key: 0,
  class: "additional-services"
}
const _hoisted_8 = {
  key: 0,
  class: "additional-services__additional-service-list"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "housing-card__divider" }, null, -1))
const _hoisted_10 = { class: "housing-card__expandable-section" }
const _hoisted_11 = { class: "housing-card__expandable-header" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "housing-card__divider" }, null, -1))
const _hoisted_13 = {
  key: 1,
  class: "housing-card__footer"
}
const _hoisted_14 = { class: "housing-card__total" }
const _hoisted_15 = {
  key: 0,
  class: "housing-card__total-price"
}
const _hoisted_16 = { class: "housing-card__price body-1-semi" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "housing-card__prices-wrapper" }
const _hoisted_19 = {
  key: 0,
  class: "housing-card__price housing-card__price--base housing-card__price--discounted"
}

import { PropType, computed, ref, watch } from 'vue'
import { formatCurrency } from '@/utils/formatters'
import BaseInput from '@/components/BaseInput.vue'
import AdditionalServiceCard, {
  AdditionalServiceInformationWithQuantity,
} from '@/components/public/AdditionalServiceCard.vue'
import HousingResultCardSearch from '@/components/public/housing/HousingResultCardSearch.vue'
import HousingUnitGuestsMapper from './HousingUnitGuestsMapper.vue'
import HousingSelectionOverview from '@/components/public/housing/HousingSelectionOverview.vue'
import { ALERT_TYPES, FORMATS, SIZES } from '@/enums/components'
import BaseButton from '../../BaseButton.vue'
import {
  HousingInformation,
  Guests,
  PeriodAvailability,
} from '@/models/public/service.model'
import { getValidationErrorData } from '@/utils/errors'
import { Alert, StringDate } from '@/models/shared.model'
import {
  useCreateOrderMutation,
  createHousingServiceOrderItem,
} from '@/queries/cart'
import {
  HousingAvailabilityPayload,
  CreateHousingServiceOrderItem,
} from '@/models/public/order.model'
import { useOrderStore } from '@/store/order'
import { useToast } from 'vue-toastification'
import { useI18n } from 'vue-i18n'
import { isNumeric } from '@/utils/general'
import BaseIcon from '@/components/BaseIcon.vue'
import { serviceResultCardCommonProps, TRANSLATION_TYPE } from '@/enums/public'
import { useFetchServiceHousingInformationMutation } from '@/queries/public/services'
import differenceInDays from 'date-fns/differenceInDays'
import format from 'date-fns/format'
import {
  areNewServiceCategoriesEnabled,
  calculateHousingGuests,
} from '@/utils/services'


export default /*#__PURE__*/_defineComponent({
  __name: 'HousingResultCard',
  props: {
  ...serviceResultCardCommonProps,
  availabilityRequest: {
    type: Object as PropType<HousingAvailabilityPayload>,
    default: () => ({
      check_in: null,
      check_out: null,
      adults: 1,
      children: 0,
    }),
  },
  periodAvailability: {
    type: Object as PropType<PeriodAvailability | undefined>,
    default: () => undefined,
  },
  isRelatedServices: {
    type: Boolean,
    default: false,
  },
  errors: {
    type: Object as PropType<Record<string, unknown> | undefined>,
    default: () => ({}),
  },
  relatedAvailableDiv: {
    type: HTMLDivElement,
    default: undefined,
  },
  showDatesSelect: {
    type: Boolean,
    default: false,
  },
},
  emits: ["cartUpdated", "update:availabilityRequest", "update:periodAvailability"],
  setup(__props, { emit }: { emit: ({
  (e: 'cartUpdated'): void
  (e: 'update:availabilityRequest', newValue: HousingAvailabilityPayload): void
  (e: 'update:periodAvailability', newValue: PeriodAvailability): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const orderStore = useOrderStore()
const i18n = useI18n()
const toast = useToast()



const availability = ref<PeriodAvailability | undefined>(
  props.periodAvailability,
)
const housingInfo = ref<HousingInformation | undefined>(undefined)
const additionalServiceQuantities = ref<Record<string, number>>({})
const requests = ref<string>('')
const isRequestsExpanded = ref<boolean>(false)
const isAddToCartLoading = ref<boolean>(false)
const isAdditionalServicesExpanded = ref<boolean>(false)
const isShowAllUnitGuests = ref<boolean>(false)
const selectedHousingUnitGuests = ref<Guests[]>([])
const errors = ref<Record<string, unknown> | undefined>(undefined)

const selectedStartDate = ref<StringDate | null>(
  props.availabilityRequest.check_in,
)
const selectedEndDate = ref<StringDate | null>(
  props.availabilityRequest.check_out,
)
const selectedAdultsCount = ref<number>(props.availabilityRequest.adults)
const selectedChildrenCount = ref<number>(props.availabilityRequest.children)

const cancelSelectedGuestsRecalculate = ref<boolean>(false)

const computedStartDate = computed<Date | null>(() => {
  const startDate: StringDate | null = selectedStartDate.value
  return startDate ? new Date(startDate) : null
})

const computedEndDate = computed<Date | null>(() => {
  const endDate: StringDate | null = selectedEndDate.value
  return endDate ? new Date(endDate) : null
})

const availabilitySearch = computed({
  get: () => {
    return {
      check_in: selectedStartDate.value,
      check_out: selectedEndDate.value,
      adults: selectedAdultsCount.value,
      children: selectedChildrenCount.value,
    }
  },
  set: (value: HousingAvailabilityPayload) => {
    selectedStartDate.value = value.check_in
    selectedEndDate.value = value.check_out
    selectedAdultsCount.value = value.adults
    selectedChildrenCount.value = value.children
  },
})

const isPeriodSelected = computed<boolean>(() => {
  return !!computedStartDate.value && !!computedEndDate.value
})

const nights = computed<number>(() => {
  return isPeriodSelected.value
    ? differenceInDays(computedEndDate.value, computedStartDate.value)
    : 1
})

const groupSize = computed(() => {
  return selectedAdultsCount.value + selectedChildrenCount.value
})

const isAvailable = computed<boolean>(
  () =>
    !!(
      availability.value &&
      !availability.value?.is_min_advance_time_past &&
      availability.value.available_guests >= groupSize.value
    ),
)

const isDiscounted = computed<boolean>(() => {
  return housingInfo.value?.base_total !== housingInfo.value?.discounted_total
})

const isAddToCartDisabled = computed<boolean>(() => {
  return (
    props.isPreview ||
    !props.service.id ||
    !availability.value ||
    !isAvailable.value
  )
})

const anySelected = computed<boolean>(() => {
  return (
    selectedHousingUnitGuests.value.filter(
      (item) => item.adults || item.children,
    ).length > 0
  )
})

const housingUnitGuests = computed<Guests[]>(() => {
  const housingUnits =
    Array.from(Array(getMaxHousingUnits()).keys()).map(() => ({
      adults: 0,
      children: 0,
    })) || []
  return housingUnits.map((item, index) => ({
    adults: selectedHousingUnitGuests.value[index]?.adults || 0,
    children: selectedHousingUnitGuests.value[index]?.children || 0,
  }))
})

const additionalServicesWithQuantities = computed<
  AdditionalServiceInformationWithQuantity[]
>(() => {
  const additionalServices = housingInfo.value?.additional_services ?? []

  return additionalServices.map((item) => {
    return {
      ...item,
      quantity: additionalServiceQuantities.value[item.id] || 0,
    }
  })
})

const nonZeroSelectedHousingUnitGuests = computed<Guests[]>(() => {
  return selectedHousingUnitGuests.value.filter(
    (item) => item.adults || item.children,
  )
})

const orderItemPayload = computed<CreateHousingServiceOrderItem>(() => {
  return {
    service: props.service.id,
    check_in: selectedStartDate.value,
    check_out: selectedEndDate.value,
    requests: requests.value,
    additional_services: additionalServiceQuantities.value,
    guests: nonZeroSelectedHousingUnitGuests.value,
    referral_type: props.referral?.referral_type,
    referral_code: props.referral?.referral_code,
    item_group: null,
  }
})

const alerts = computed<Alert[]>(() => {
  const alertList: Alert[] = []
  const nonFieldErrors = (errors.value?.non_field_errors || []) as Array<string>
  for (const errorMessage of nonFieldErrors) {
    alertList.push({
      text: errorMessage,
      alertType: ALERT_TYPES.DANGER,
    })
  }
  if (!availability.value && housingInfo.value) {
    alertList.push({
      text: i18n.t('searchToSeeResultsInfo', {
        maxGroupSize: housingInfo.value?.housing.max_guests,
      }),
      alertType: ALERT_TYPES.INFO,
    })
  }
  if (availability.value?.is_min_advance_time_past) {
    alertList.push({
      text: i18n.t('minAdvanceTimePastWarning'),
      alertType: ALERT_TYPES.WARNING,
    })
  }
  return alertList
})
const updateAdditionalServiceQuantity = (item: Record<string, number>) => {
  additionalServiceQuantities.value[item.id] = item.quantity
}

const { mutateAsync: fetchHousingInfo, isLoading: isLoadingHousingInfo } =
  useFetchServiceHousingInformationMutation()

const updateHousingInfo = async () => {
  if (!isPeriodSelected.value || !props.service) {
    return
  }

  errors.value = undefined
  fetchHousingInfo({
    serviceId: props.isPreview ? props.service.id : props.service.hash_id,
    group_service: props.groupService,
    isPreview: props.isPreview,
    check_in: format(computedStartDate.value, 'yyyy-MM-dd'),
    check_out: format(computedEndDate.value, 'yyyy-MM-dd'),
    additional_services: additionalServiceQuantities.value,
    guests: nonZeroSelectedHousingUnitGuests.value,
  })
    .then((data) => {
      housingInfo.value = data
    })
    .catch((error) => {
      const validationErrors = getValidationErrorData(error)
      // todo: temp check
      delete validationErrors?.non_field_errors
      errors.value = validationErrors
    })
}

const { mutateAsync: createOrder } = useCreateOrderMutation()

const addHousingServiceItemToCart = async () => {
  isAddToCartLoading.value = true
  errors.value = undefined
  if (!orderStore.orderUuid) {
    try {
      const data = await createOrder()
      orderStore.updateOrder(data)
    } catch (error: unknown) {
      errors.value = getValidationErrorData(error)
      isAddToCartLoading.value = false
      return
    }
  }

  createHousingServiceOrderItem(orderStore.orderUuid, orderItemPayload.value)
    .then((response) => {
      orderStore.updateOrder(response.data)
      toast.success(i18n.t('addToCartSuccess'))
      emit('cartUpdated')
    })
    .catch((error) => {
      errors.value = getValidationErrorData(error)
    })
    .finally(() => {
      isAddToCartLoading.value = false
    })
}

const toggleUnitGuests = () => {
  isShowAllUnitGuests.value = !isShowAllUnitGuests.value
}

const scrollToRelatedServices = () => {
  props.relatedAvailableDiv?.scrollIntoView({ behavior: 'smooth' })
}

function getMaxHousingUnits(newAvailability?: PeriodAvailability) {
  return (
    (newAvailability || availability.value)?.available_quantity ??
    housingInfo.value?.housing.quantity ??
    0
  )
}

function recalculateSelectedHousingUnitGuests(
  cancel_update: boolean | undefined = undefined,
) {
  if (cancel_update === undefined) {
    cancel_update = cancelSelectedGuestsRecalculate.value
  }
  if (!cancel_update) {
    selectedHousingUnitGuests.value = calculateHousingGuests(
      selectedAdultsCount.value,
      selectedChildrenCount.value,
      getMaxHousingUnits(availability.value),
      availability.value?.max_guests_per_quantity,
    )
  }
  cancelSelectedGuestsRecalculate.value = false
}

function getAdultsCount(newValue?: Guests[]) {
  return (newValue || selectedHousingUnitGuests.value).reduce(
    (acc: number, value: Guests) => acc + value.adults,
    0,
  )
}

function getChildrenCount(newValue?: Guests[]) {
  return (newValue || selectedHousingUnitGuests.value).reduce(
    (acc: number, value: Guests) => acc + value.children,
    0,
  )
}

const updateHousingUnitGuests = (item: Guests, index: number) => {
  if (!item.adults && !item.children) {
    selectedHousingUnitGuests.value.splice(index, 1)
  } else {
    selectedHousingUnitGuests.value[index] = item
  }

  selectedAdultsCount.value = getAdultsCount()
  selectedChildrenCount.value = getChildrenCount()

  // we don't want automatic calculation to undo user's reallocation
  cancelSelectedGuestsRecalculate.value = true
}

// before availability watch because we want this immediate to trigger first
// and will selectedHousingUnits for first updateHousingInfo call
watch(
  () => [selectedAdultsCount, selectedChildrenCount],
  () => {
    recalculateSelectedHousingUnitGuests()
  },
  { immediate: true },
)

watch(
  availability,
  async () => {
    emit('update:periodAvailability', availability.value)
    await updateHousingInfo()
    recalculateSelectedHousingUnitGuests()
  },
  { immediate: true },
)

watch(
  () => props.availabilityRequest,
  () => {
    availabilitySearch.value = props.availabilityRequest
  },
)

watch(availabilitySearch, () => {
  emit('update:availabilityRequest', availabilitySearch.value)
})

watch(
  () => getMaxHousingUnits(),
  () => {
    recalculateSelectedHousingUnitGuests(false)
  },
)

watch(
  () => props.periodAvailability,
  () => {
    availability.value = props.periodAvailability
  },
)

watch(
  () => props.errors,
  () => {
    errors.value = props.errors
  },
  { immediate: true },
)



return (_ctx: any,_cache: any) => {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_AlertBanner = _resolveComponent("AlertBanner")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["housing-card", { 'result-card--grouped': !!props.groupService }])
  }, [
    _renderSlot(_ctx.$slots, "header", {}, () => [
      (!_ctx.hideHeader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createTextVNode(_toDisplayString(_ctx.service?.name?.content) + " ", 1),
                (_ctx.service?.name?.type === _unref(TRANSLATION_TYPE).MACHINE)
                  ? (_openBlock(), _createBlock(BaseIcon, {
                      key: 0,
                      icon: "google-translate",
                      style: {"height":"16px","min-height":"16px","width":"revert","display":"block"}
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(areNewServiceCategoriesEnabled)
              ? _ctx.service.vat_category.name
              : _ctx.service.category.name), 1),
              (_unref(isLoadingHousingInfo))
                ? (_openBlock(), _createBlock(_component_LoadingSpinner, {
                    key: 0,
                    class: "housing-card__loader"
                  }))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(alerts), (alert, alertIndex) => {
      return (_openBlock(), _createBlock(_component_AlertBanner, _mergeProps({ key: alertIndex }, alert), null, 16))
    }), 128)),
    (availability.value && !_unref(isAvailable))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (__props.isRelatedServices)
            ? (_openBlock(), _createBlock(_component_AlertBanner, {
                key: 0,
                text: _ctx.$t('noAvailabilityRecommendation'),
                "button-label": _ctx.$t('here'),
                "alert-type": _unref(ALERT_TYPES).WARNING,
                onButtonClick: _cache[0] || (_cache[0] = ($event: any) => (scrollToRelatedServices()))
              }, null, 8, ["text", "button-label", "alert-type"]))
            : (_openBlock(), _createBlock(_component_AlertBanner, {
                key: 1,
                text: _ctx.$t('noAvailabilityWarning'),
                "alert-type": _unref(ALERT_TYPES).WARNING
              }, null, 8, ["text", "alert-type"]))
        ], 64))
      : _createCommentVNode("", true),
    (__props.showDatesSelect && !_ctx.showSelectedMode)
      ? (_openBlock(), _createBlock(HousingResultCardSearch, {
          key: 1,
          modelValue: _unref(availabilitySearch),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(availabilitySearch) ? (availabilitySearch).value = $event : null)),
          service: _ctx.service,
          "group-service": _ctx.groupService,
          onPeriodAvailability: _cache[2] || (_cache[2] = (value) => (availability.value = value))
        }, null, 8, ["modelValue", "service", "group-service"]))
      : _createCommentVNode("", true),
    (housingInfo.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (!_ctx.showSelectedMode)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(housingUnitGuests), (item, index) => {
                  return _withDirectives((_openBlock(), _createElementBlock("div", {
                    key: index + JSON.stringify(item)
                  }, [
                    _createVNode(HousingUnitGuestsMapper, {
                      "housing-info": housingInfo.value,
                      "model-value": item,
                      errors: errors.value?.guests?.[index],
                      disabled: !availability.value || !_unref(isAvailable),
                      "min-adults": item.children ? 1 : 0,
                      class: "housing-card__unit-wrapper",
                      "onUpdate:modelValue": (item) => updateHousingUnitGuests(item, index)
                    }, null, 8, ["housing-info", "model-value", "errors", "disabled", "min-adults", "onUpdate:modelValue"]),
                    _hoisted_5
                  ])), [
                    [_vShow, 
            isShowAllUnitGuests.value || index < selectedHousingUnitGuests.value.length
          ]
                  ])
                }), 128)),
                (_unref(housingUnitGuests).length > selectedHousingUnitGuests.value.length)
                  ? (_openBlock(), _createBlock(BaseButton, {
                      key: 0,
                      label: _ctx.$t('housingUnit.displayAll'),
                      format: _unref(FORMATS).TERTIARY,
                      size: _unref(SIZES).SMALL,
                      icon: isShowAllUnitGuests.value ? 'chevron-up' : 'chevron-down',
                      "icon-right": true,
                      class: "housing-card__unit-guests-toggle",
                      onClick: _withModifiers(toggleUnitGuests, ["prevent"])
                    }, null, 8, ["label", "format", "size", "icon", "onClick"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_6, [
                    (_unref(additionalServicesWithQuantities).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("div", null, [
                            _createVNode(BaseButton, {
                              label: _ctx.$t('additionalServices'),
                              format: _unref(FORMATS).TERTIARY,
                              size: _unref(SIZES).MEDIUM,
                              icon: 
                      isAdditionalServicesExpanded.value
                        ? 'chevron-up'
                        : 'chevron-down'
                    ,
                              "icon-right": true,
                              class: "housing-card__section-toggle",
                              onClick: _cache[3] || (_cache[3] = _withModifiers(
                      () =>
                        (isAdditionalServicesExpanded.value =
                          !isAdditionalServicesExpanded.value)
                    , ["prevent"]))
                            }, null, 8, ["label", "format", "size", "icon"])
                          ]),
                          (isAdditionalServicesExpanded.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(additionalServicesWithQuantities), (item) => {
                                  return (_openBlock(), _createBlock(AdditionalServiceCard, {
                                    key: item.id,
                                    "model-value": item,
                                    disabled: !availability.value || !_unref(isAvailable),
                                    "onUpdate:modelValue": 
                      (item) => updateAdditionalServiceQuantity(item)
                    
                                  }, null, 8, ["model-value", "disabled", "onUpdate:modelValue"]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(BaseButton, {
                          label: _ctx.$t('specialRequest'),
                          format: _unref(FORMATS).TERTIARY,
                          size: _unref(SIZES).MEDIUM,
                          icon: isRequestsExpanded.value ? 'chevron-up' : 'chevron-down',
                          "icon-right": true,
                          class: "housing-card__section-toggle",
                          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (isRequestsExpanded.value = !isRequestsExpanded.value), ["prevent"]))
                        }, null, 8, ["label", "format", "size", "icon"])
                      ]),
                      (isRequestsExpanded.value)
                        ? (_openBlock(), _createBlock(BaseInput, {
                            key: 0,
                            modelValue: requests.value,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((requests).value = $event)),
                            label: _ctx.$t('requests'),
                            name: "requests",
                            class: "housing-card__requests",
                            type: "textarea",
                            resizable: "",
                            errors: errors.value?.requests
                          }, null, 8, ["modelValue", "label", "errors"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _hoisted_12
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_unref(isAvailable))
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  (!_ctx.isPriceHidden)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          (!_ctx.showSelectedMode)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t('plurals.numberOfNights', _unref(nights))), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_18, [
                            (_unref(isDiscounted))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(isNumeric)(housingInfo.value?.base_total)
                      ? _unref(formatCurrency)(housingInfo.value?.base_total)
                      : '- €'), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", {
                              class: _normalizeClass(["housing-card__price", [_unref(isDiscounted) && 'housing-card__price--discounted']])
                            }, _toDisplayString(_unref(isNumeric)(housingInfo.value?.discounted_total)
                      ? _unref(formatCurrency)(housingInfo.value?.discounted_total)
                      : '- €'), 3)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showSelectedMode)
                    ? (_openBlock(), _createBlock(HousingSelectionOverview, {
                        key: 1,
                        start: _unref(computedStartDate),
                        end: _unref(computedEndDate),
                        guests: _unref(nonZeroSelectedHousingUnitGuests),
                        "additional-services": additionalServiceQuantities.value
                      }, null, 8, ["start", "end", "guests", "additional-services"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _renderSlot(_ctx.$slots, "addButton", {
                    payload: _unref(orderItemPayload),
                    contentSelected: _unref(anySelected),
                    disabled: _unref(isAddToCartDisabled)
                  }, () => [
                    _createVNode(BaseButton, {
                      format: _unref(FORMATS).PRIMARY,
                      size: _unref(SIZES).SMALL,
                      label: _ctx.$t('addToCart'),
                      loading: isAddToCartLoading.value,
                      class: "housing-card__action",
                      icon: "suit-case",
                      disabled: _unref(isAddToCartDisabled),
                      "icon-right": "",
                      onClick: _withModifiers(addHousingServiceItemToCart, ["prevent"])
                    }, null, 8, ["format", "size", "label", "loading", "disabled", "onClick"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 2))
}
}

})